// extracted by mini-css-extract-plugin
export var closeButton = "_3w-3";
export var header = "_3w-0";
export var link = "_3w-1";
export var retryButton = "_3w-2";